import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditNoteIcon from '@mui/icons-material/EditNote';
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  FormControl,
  Stack,
  Tooltip,
  FormLabel,
  Grid,
  Typography,
  TableContainer,
  TextareaAutosize,
  TextField,
  Tabs,
  Tab,
  CircularProgress,
  Menu, 
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useCurrencies } from "../CashAllocation/hooks";
import DialogueContainer from "../CashAllocation/DialogueContainer";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Card } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import format from "date-fns/format";
import {
  BankTransaction,
  GetUsers,
  MutlipleAssignTxnUser,
  getBrokerBranchDetailsByBrokerBranchName,
  fetchFile,
} from "../../Services/api";
import instance from "../../redux/api";
import { BANK_STATEMENT_ROW_DATA } from "../../utils/config";
import DialogBox from "../common/dialog";
import "./bankTransaction.css";
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
import CommonFileUpload from "../documents/CommonFileUpload";
import { ViewAndEditBankTransaction } from "./ViewAndEditTxnDialog";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import { AddBnkTransactionDetails } from "./AddBnkTransactionDetails";
import { CommonButton } from "../common/commonButton";
import "../common/commonPageStyles.css";
import {
  getAccountsList,
  getBrokerBranchesList,
  getCurrencyList,
  getTxnCategoryList
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { useStyles } from "./bankTranscationContainerStyles";
import { numberFormatter } from "../../utils/generalFunctions";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
import { downloadFileModdules } from "../CashAllocation/constants";
import { commonToast } from "../common";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { policyActions } from "./constants";
import { ROEFILTERAPI } from "../../Services/api";

const dialogStyle = {
  maxWidth: "90vw",
  width: "90vw",
  margin: "auto",
};


export default function BankTransactionsConatiner() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);

  const accountsList = useSelector(
    (state) => state?.bankStatmentTransactions?.accountsList
  );
  const brokerBranches = useSelector(
    (state) => state?.bankStatmentTransactions?.brokerBranchesList
  );
  const dropdownValuesCurreny = useSelector(
    (state) => state?.bankStatmentTransactions?.currencyList
  );
  const dropdownValuesTxnCategory = useSelector(
    (state) => state?.bankStatmentTransactions?.txnCategoryList
  );

  const dispatch = useDispatch();

  // Local State
  const [selectedOption, setSelectedOption] = useState("");
  const [isOpenAddBankTxnDialog, setIsOpenAddBankTxnDialog] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isCreateNewTransaction, setIsCreateNewTransaction] = useState(true);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [isDeletebankTxnProgress, setIsDeletebankTxnProgress] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInputValue, setDialogInputValue] = useState("");
  const [currentPaymentReferenceIndex, setCurrentPaymentReferenceIndex] =
    useState(0);

  const [selectionModel, setSelectionModel] = useState([]);

  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [isDeleteTxnIdValidation, setIsDeleteTxnIdValidation] = useState(null);

  const [rows, setRows] = useState([
    { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
  ]);
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});

  // File Upload
  const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  //bank statement transaction search
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Bank_Name: "",
    Receiving_Bank_Account: "",
    Bank_Transaction_Id: "",
  });

  const [currentRow, setCurrentRow] = useState("");
  const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false);
  const [txnMode, setTxnMode] = useState("VIEW");
  const [isAuditOpen, setIsAuditOpen] = useState(false);

  //Pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isAccountDeSelected, setIsAccountDeSelected] = useState(false);
  const [isAssignToTxnApiProgress, setIsAssignToTxnApiProgress] =
    useState(false);

  const location = useLocation();
  // const [filterAssigned, setFilterAssigned]=useState(location.state.assigned);

  const [tabValue, setTabValue] = useState(1);
  const [allocationType, setAllocationType] = useState("Unallocated");
  const [isBankNameSelected, setIsBankNameSelected] = useState(false);

  // Add a new state variable at the beginning of your component to track if the submit has been initiated
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [dialogType, setDialogType] = useState("");
  const [currentCommentIndex, setCurrentCommentIndex] = useState(0);

  const [downloadingFiles, setDownloadingFiles] = useState({});

  // Filter search states
  const [bankNameSearch, setBankNameSearch] = useState("");
  const [accountNoSearch, setAccountNoSearch] = useState("");
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  //styles
  const classes = useStyles();

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const handleTabChange = async (_, newValue) => {
    setTabValue(newValue);
    let selectedOption = !newValue ? "Allocated" : "Unallocated";
    setAllocationType(selectedOption);
    setPageState((old) => ({
      ...old,
      page: 1,
      pageSize: 25,
    }));
  };

  const handleBankTransactionIdchange = (name, value) => {
    if (!value) {
      handleClearSearchList();
    }
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: value?.trim(),
    });
  };

  const handleBankTnxSelectAccountDropdown = (name, value, reason) => {
    if (reason === "clear") {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        [name]: "",
      });
      setIsAccountDeSelected(true);
    } else {
      setIsAccountDeSelected(false);
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        [name]: value,
      });
    }
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const { Bank_Transaction_Id } = searchFieldsPrams;

    // Handle single bank name selection (only first one is sent to backend)
    if (selectedBanks.length > 0) {
      getSearchQueryParams = `${getSearchQueryParams}&bankName=${selectedBanks[0]}`;
    }

    // Handle single account number selection (only first one is sent to backend)
    if (selectedAccounts.length > 0) {
      getSearchQueryParams = `${getSearchQueryParams}&accountNo=${selectedAccounts[0]}`;
    }

    if (Bank_Transaction_Id) {
      getSearchQueryParams = `${getSearchQueryParams}&transactionId=${Bank_Transaction_Id}`;
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "dd/MM/yyyy");
      formattedToDateValue = format(toDateValue, "dd/MM/yyyy");
      getSearchQueryParams = `${getSearchQueryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchBankTransactionList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromDate")
      ) {
        let formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "dd/MM/yyyy"
        );
        let formattedToDateValue = format(
          location?.state?.toDateValue,
          "dd/MM/yyyy"
        );
        queryParams = `${queryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
      }

      let assigned = location?.state?.assigned || "";
      if (assigned) {
        queryParams = `${queryParams}&assigned=${assigned}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${BankTransaction}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
        // clear previous row selection
        handleSelectionModelChange([]);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.log("error", error);
    }
  };

  const handleClearSearchList = async () => {
    // Clear all filter states
    setSelectedBanks([]);
    setSelectedAccounts([]);
    setBankNameSearch("");
    setAccountNoSearch("");
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    // clear fields
    setSearchFieldsPrams({
      Bank_Name: "",
      Receiving_Bank_Account: "",
      Bank_Transaction_Id: "",
    });
    getBankAccountsList("");
    setFromDateValue("");
    setToDateValue("");
  };

  const bankTransactionPermisson =
    userData?.user_permissions?.permissions_list["Bank Transactions"] ?? {};

  useEffect(() => {
    // Fetch users data from an API
    instance
      .get(GetUsers)
      .then((data) => {
        const filteredUsers = data.data.filter(
          (user) => (user.role === "CC Processor" || user.role === "Lead Role") && user.status === "Active"
        );
        setUsers([...new Set(filteredUsers)]);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const handleSubmitAssing = async () => {
    const assigningToInfo = users?.filter(
      (item) => item?.user_name === selectedUser
    );
    const assigningToId = assigningToInfo[0]?.id;

    const selectedRowsData =
      pageState?.data?.filter((row) => selectionModel.includes(row.id)) ?? [];

    try {
      setIsAssignToTxnApiProgress(true);
      const response = await instance.post(MutlipleAssignTxnUser, {
        user_login_id: assigningToId,
        Bank_Transaction_Ids: selectedRowsData?.map((item) => ({
          id: item.id,
        })),
      });
      if (response?.status === 200) {
        setIsAssignToTxnApiProgress(false);
        handleCloseDialog();
        handleSelectionModelChange([]);
        commonToast("success", "Assign successful!");
        loadData();
      } else {
        setIsAssignToTxnApiProgress(false);
        commonToast("error", "Something Went Wrong");
      }
    } catch (err) {
      console.log("err", err);
      setIsAssignToTxnApiProgress(false);
      commonToast("error", "Something Went Wrong");
    }
  };

  const handleAssignButtonClick = (params) => {
    setSelectedUser("");
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  // Function to handle individual checkbox change
  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  // Function to handle "Select All" checkbox change
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
    // Fetch Broker branches
    dispatch(getBrokerBranchesList());
    // Fetch Currency Details
    dispatch(getCurrencyList());
    // Fetch txn Category List
    dispatch(getTxnCategoryList());
    // Load data initially and on specific dependency changes
    if (!isSearchPerformed) {
      loadData();
    }
  }, [
    dispatch,
    allocationType,
    pageState?.pageSize,
    pageState?.page,
    isAccountDeSelected,
    isClearPerformed,
    isSearchPerformed,
  ]);

  const handleBankAccountDropdownChange = (value, reason = "") => {
    if (reason === "clear") {
      setSelectedOption(value);
      setResponseData({});
    } else {
      setSelectedOption(value);
    }
  };

  // Add Mode
  useEffect(() => {
    if (selectedOption) {
      if (selectedOption === "Select Account") {
        setResponseData({});
      } else {
        const getInfo = accountsList?.filter(
          (item) => item.account_number === selectedOption
        );
        setResponseData(getInfo[0]);
      }
    }
  }, [selectedOption]);

  const handleActionButton = (currentRowData, currentTxnMode) => {
    setCurrentRow(currentRowData);
    setTxnMode(currentTxnMode);
    if (currentTxnMode === 'AUDIT') {
      setIsAuditOpen(true);
    } else { 
      setIsOpenTxnDialog(true);
    }
  };

  const handleActivityButton = (event, currentRowData, currentTxnMode) => {
    setAnchorEl(event.currentTarget);
    setMenuId(currentRowData?.id);
    setTxnMode(currentTxnMode);
    setCurrentRow(currentRowData);
  };

  const handleAddTxnButton = () => {
    // Create an array of empty objects with the same structure as your rows
    const emptyRows = Array.from({ length: rows.length }, () => ({
      ...BANK_STATEMENT_ROW_DATA,
      Receiving_Bank_Account: selectedOption,
    }));

    setRows(emptyRows);
    setIsCreateNewTransaction(true);
    setSelectedOption("");

    setIsOpenAddBankTxnDialog(true);
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      ...BANK_STATEMENT_ROW_DATA,
      Receiving_Bank_Account: selectedOption,
    }));
    setRows(emptyRows);

    setResponseData({});
    setOpenResetDialog(false);
    handleBankAccountDropdownChange("");
    setUploadedFiles([]);
  };

  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const handleErrorDialogClose = () => {
    setOpenErrorDialog(false);
  };

  const handleDeleteClick = async (id, transaction_id) => {
    setIdToDelete(id);
    const response = await instance.get(
      `bankmanagement/get_transactions_by_txn_id_validation/?txn_id=${encodeURIComponent(transaction_id)}`
    );
    if (response.status === 200 && response?.data?.message === "Not Success") {
      setOpen(true);
      setIdToDelete(id)
    } else {
      setOpenErrorDialog(true);
      setIsDeleteTxnIdValidation(transaction_id);
    }
  };

  const handleDeleteConfirmed = async () => {
    try {
      setIsDeletebankTxnProgress(true);
      // Send DELETE request to your API
      const response = await instance.delete(BankTransaction + idToDelete);

      // Check if the deletion was successful
      if (response.status === 200) {
        setIsDeletebankTxnProgress(false);
        // If successful, show a success toast
        commonToast("success", "Transaction deleted successfully");
        setOpen(false);
        handleErrorDialogClose(false);
        setIdToDelete(null);

        loadData();
        // If needed, update the state to reflect the deletion
        const updatedRows = rows.filter((row) => row.id !== idToDelete);
        setRows(updatedRows);
      } else {
        setIsDeletebankTxnProgress(false);
        // If deletion was not successful, show an error toast
        commonToast("error", `Error deleting item: ${response.statusText}`);
      }
    } catch (error) {
      setIsDeletebankTxnProgress(false);
      // If an error occurs during deletion, show an error toast
      commonToast("error", `Error deleting item: ${error.message}`);
    }
  };

  const handleDownloadFile = async (bucketKey, documentName = null) => {
    try {
      setDownloadingFiles((prev) => ({ ...prev, [bucketKey]: true }));
      const module = downloadFileModdules.bankStatementTransactions;
      const url = `${fetchFile}?key=${bucketKey}&module=${module}`;
  
      const response = await instance.get(url, { responseType: "blob" });
      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = documentName || bucketKey || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Cleanup
      window.URL.revokeObjectURL(fileURL);
      
      showToast("success", "File downloaded successfully.");
    } catch (error) {
      showToast("error", "Failed to open the file.");
    } finally {
      setDownloadingFiles((prev) => {
        const updated = { ...prev };
        delete updated[bucketKey];
        return updated;
      });
    }
  }

  const showToast = (type, message) => {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  };

  const [menuId, setMenuId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogueId, setOpenDialogueId] = useState("");
  const [dialogueAllocation, setDialogueAllocation] = useState(null);
  const currencies = useCurrencies();
  const handleClose = (id, allocation) => {
    setOpenDialogueId((prev) => (prev === id ? "" : id));
    setAnchorEl(null);
    setMenuId(null);
    setDialogueAllocation(allocation);
  };

  const handleDeleteCancelled = () => {
    setOpen(false);
    setIdToDelete(null);
  };

  const columns = [
    {
      field: "Bank_Transaction_Id",
      headerName: "Transaction ID",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "Payment_Receive_Date",
      headerName: "Payment Rcv Date",
      headerClassName: "split-header",
      minWidth: 140,
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value,
      valueFormatter: (params) => {
        // Format the date using date-fns or any other date formatting library
        return customDateFormat(params.value);
      },
    },
    {
      field: "Bank_Account_Name_Entity",
      headerName: "Bank Name",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => params.row?.bank_details?.bank_name,
      renderCell: (params) => <>{params.row?.bank_details?.bank_name ?? ""}</>,
    },
    {
      field: "Broker_Branch",
      headerName: "Broker Name",
      headerAlign: "center",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "Assigned_User",
      headerName: "Assign To",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => params?.row?.Assigned_User?.user_name,
      renderCell: (params) => (
        <>{params?.row?.Assigned_User?.user_name ?? ""}</>
      ),
      filterable: true, // Enable filtering for this column
    },
    {
      field: "assigned_date",
      headerName: "Assigned Date",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => params?.row?.assigned_date,
      renderCell: (params) => {
        return params.row?.assigned_date
          ? format(new Date(params.row?.assigned_date), "dd-MM-yyyy")
          : "";
      },
    },
    // CMT-28
    {
      field: "transaction_status",
      headerName: "Status",
      headerAlign: "center",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => params?.row?.transaction_status,
      renderCell: (params) => <>{params?.row?.transaction_status ?? ""}</>,
    },
    {
      field: "Receivable_Amount",
      headerName: "Rcvd Settlement Amt",
      headerAlign: "center",
      headerClassName: "split-header",
      minWidth: 160,
      flex: 1,
      valueGetter: (params) => params?.value,
      valueFormatter: (params) => {
        return numberFormatter(params?.value ?? 0);
      },
      cellClassName: "amount-table-cell",
    },
    {
      field: "txn_type",
      headerName: "Transaction Type",
      headerAlign: "center",
      headerClassName: "split-header",
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        const txnType = params.row.txn_type;
        if (txnType) {
          return txnType; // Return txn_type if it's not null
        }
        const receivableAmount = params.row.Receivable_Amount;
        if (receivableAmount > 0) {
          return "Inflow";
        } else if (receivableAmount < 0) {
          return "Outflow";
        } else {
          return null;
        }
      },
    },
    {
      field: "total_allocated",
      headerName: "Allocated Amount",
      headerAlign: "center",
      headerClassName: "split-header",
      minWidth: 100,
      flex: 1,
      valueGetter: (params) => params?.row?.total_allocated,
      valueFormatter: (params) => {
        return numberFormatter(params?.value ?? 0);
      },
      cellClassName: "amount-table-cell",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      minWidth: 200,
      flex: 1,
      description: "This column has a value getter and is not sortable.",
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];

        if (bankTransactionPermisson?.["Edit"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Edit">
                  {" "}
                  <EditIcon sx={{ color: "#1672DE" }} />{" "}
                </Tooltip>
              }
              label="Edit"
              className="textPrimary"
              onClick={() => handleActionButton(row, "EDIT")}
              color="inherit"
            />
          );
        }

        if (bankTransactionPermisson?.["Delete"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Delete">
                  <DeleteIcon sx={{ color: "#1672DE" }} />{" "}
                </Tooltip>
              }
              label="Delete"
              onClick={() => handleDeleteClick(row.id, row.Bank_Transaction_Id)}
              color="inherit"
            />
          );
        }

        if (bankTransactionPermisson?.["View"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="View">
                  {" "}
                  <VisibilityIcon sx={{ color: "#1672DE" }} />{" "}
                </Tooltip>
              }
              label="view"
              className="textPrimary"
              onClick={() => handleActionButton(row, "VIEW")}
              color="inherit"
            />
          );
        }

        if (bankTransactionPermisson?.["View"] === "Y") {
          actionsList.push(
            <GridActionsCellItem
              icon={
                <Tooltip title="Audit Trail">
                  {" "}
                  <EditNoteIcon sx={{ color: "#1672DE" }} />{" "}
                </Tooltip>
              }
              label="audit"
              className="textPrimary"
              onClick={() => handleActionButton(row, "AUDIT")}
              color="inherit"
            />
          );
        }

        if (bankTransactionPermisson?.["View"] === "Y") {
          actionsList.push(
            <>
              <Tooltip title="Activity">
                <span>
                  <Button
                    id={`demo-positioned-button-${row.id}`}
                    aria-controls={menuId === row.id ? "demo-positioned-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={menuId === row.id ? "true" : undefined}
                    onClick={(e) => handleActivityButton(e, row, "ACTIVITY")}
                    className="action-button pill"
                    disabled={row?.has_ca}
                    sx={{
                      backgroundColor: "transparent !important", 
                      padding: "0px", 
                      minWidth: "0px !important",
                      borderRadius: "0px",
                      color: "#1672DE !important",
                      "&:hover": {
                        backgroundColor: "transparent !important",
                        color: "#1565c0 !important",
                      }
                    }}
                  >
                    <MoreHorizIcon />
                  </Button>
                </span>
              </Tooltip>
            </>
          );
        }

        return actionsList;
      },
    },
    {
      field: "File_Name",
      headerName: "Review Bk Stmt/Preview",
      headerClassName: "split-header",
      headerAlign: "center",
      align: "right",
      sortable: false,
      description: "This column has a value getter and is not sortable.",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        const fileName = params?.row?.File_Name;
        const isDownloading = downloadingFiles[fileName];
        
        return (
          <div style={{ cursor: 'pointer' }}>
            {fileName && (
              isDownloading ? (
                <CircularProgress 
                  size={24}
                  style={{ color: "#1672DE" }}
                />
              ) : (
                <DownloadIcon
                  style={{ color: "#1672DE" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadFile(
                      fileName,
                      params?.row?.bank_reconciliation?.file_name
                    );
                  }}
                />
              )
            )}
          </div>
        );
      }
    },
  ];

  const handleDialogClose = () => {
    setResponseData({});
    setIsOpenAddBankTxnDialog(false);
    setEditMode(false);
    setViewMode(false);
    setValidationStatus(Array(rows.length).fill(true));
    setUploadedFiles([]);

    // reset Rows To Initial State
    resetRowsToInitialState();
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let assigned = location?.state?.assigned || "";
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}&allocated=${allocationType}`;

      if (assigned) {
        queryParams = `${queryParams}&assigned=${assigned}`;
      }

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      let formattedFromDateValue = "";
      let formattedToDateValue = "";

      if (location?.state?.fromDateValue && location?.state?.toDateValue) {
        formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "dd/MM/yyyy"
        );
        formattedToDateValue = format(
          location?.state?.toDateValue,
          "dd/MM/yyyy"
        );
        queryParams = `${queryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
      }

      const response = await instance.get(`${BankTransaction}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  // Handler for Bank Name Dropdown (kept for backward compatibility if needed)
  const handleBankNameDropdownChange = (name, value, reason) => {
    console.log("name, value, reason", name, value, reason);
    if (reason === "clear") {
      setIsBankNameSelected(false);
      setSearchFieldsPrams((prev) => ({
        ...prev,
        [name]: value,
        Receiving_Bank_Account: null,
      })); // Also reset Account No when Bank Name is cleared
      getBankAccountsList("");
    } else {
      setIsBankNameSelected(true);
      setSearchFieldsPrams((prev) => ({ ...prev, [name]: value }));
      getBankAccountsList(value);
    }
  };

  // Update account list when selected banks change
  useEffect(() => {
    if (selectedBanks.length > 0) {
      // If multiple banks selected, get accounts for all banks
      // For now, we'll get accounts for the first selected bank
      // You may want to modify this to handle multiple banks
      getBankAccountsList(selectedBanks[0]);
    } else {
      getBankAccountsList("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBanks]);

  const [banksList, setBanksList] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState("");

  const getBanksList = async () => {
    const response = await instance.get("documents/get_all_unique_bank_names/");
    setBanksList(response?.data?.bank_names);
  };

  const getBankAccountsList = async (value) => {
    const response = await instance.get(
      `documents/get_all_unique_account_numbers_by_bank_name/?bank_name=${value}`
    );
    setSelectedBankAccount(response?.data?.account_numbers);
  };

  useEffect(() => {
    getBanksList();
    getBankAccountsList("");
  }, []);

  const handleSubmit = async () => {
    setIsSubmitting(true); // Disable the button when submit starts
    const hasFutureDate = rows.some((item) => {
      const paymentReceiveDate = new Date(item.Payment_Receive_Date);
      const today = new Date();
      return paymentReceiveDate > today;
    });

    if (hasFutureDate) {
      setIsSubmitting(false);
      commonToast("error", "Payment_Receive_Date cannot be in the future.");
      return; // Exit the function if there is a future date
    }

    // Add Mode
    rows.forEach((item) => {
      item["Allocation_Status"] = "Open";
      item["Accounting_Month"] = format(new Date(), "yyyy-MM-dd");
      // Specific Data
      item["Receiving_Bank_Account"] = selectedOption;
      item["bank_details"] = responseData?.id;
      item["Bank_Account_Name_Entity"] = responseData?.bank_name;
      item["PT_Receving_Bank_Name"] = responseData?.entity_name;
      item["Bank_Currency_Code"] = responseData?.currency;
      if (item["Txn_Category"] === "Non Premium") {
        item["transaction_status"] = "Completed"
      }
      else {
        item["transaction_status"] = "Open"
      }
      if (!item["comment"] || item["comment"].trim() === "") {
        item["comment"] = null;
      }
    });

    // Validate each row before submission
    const areRowsValid = rows.every((_, index) => validateRow(index));
    //const areRowsValid = true;

    if (!areRowsValid) {
      setIsSubmitting(false);
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }

    try {
      let response = await instance.post(BankTransaction, rows);
      if (response) {
        if (uploadedFiles?.length) {
          const responseData = response?.data;
          let transactionsIds = [];
          responseData?.forEach((elemet) => {
            transactionsIds.push({ id: elemet.id });
            // transactionsIds.push({ id: elemet["Bank_Transaction_Id"] })
          });

          const form = new FormData();
          var transactionsIdsString = JSON.stringify(transactionsIds);
          form.append("transaction_ids", transactionsIdsString);
          form.append("File_Name", uploadedFiles[0].file ?? "");

          // form.append("document_name", uploadedFiles[0].name);
          // form.append("document_details", uploadedFiles[0].details ?? "");

          return instance
            .post("bankmanagement/file_upload_to_transactions/", form, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response?.data[0]?.["File_Name"]) {
                commonToast("success", "Submission successful !");
                cleanupTransactionData();
                // reset Rows To Initial State
                resetRowsToInitialState();
              } else {
                commonToast("error", "Transaction created but File Upload got fail");
                // reset Rows To Initial State
                resetRowsToInitialState();
              }
            })
            .catch((error) => {
              commonToast("error", "Transaction created but File Upload got fail");
              console.error("Error fetching dropdown values:", error);
            });
        } else {
          commonToast("success", "Submission successful !");
        }
      }

      // clean up
      cleanupTransactionData();
    } catch (err) {
      setIsSubmitting(false);
      commonToast("error", "Submission failed. Please try again.");
    }
    setIsSubmitting(false); // Re-enable the button after submit is complete
  };

  // clean up data and close add or edit transaction dialog
  const cleanupTransactionData = () => {
    handleDialogClose();
    setResponseData({});
    loadData();
  };

  const errorMessages = {
    Bank_Exchange_Rate: "Exchange Rate cannot be negative.",
    // Bank_Exchange_Charges: "Exchange Charges cannot be negative.",
    Bank_Charges: "Bank Charges cannot be negative.",
  };

  const handleInputChange = async (index, colName, value) => {
    if (
      // Bank exchnage is not required
      // ["Bank_Exchange_Rate", "Bank_Exchange_Charges", "Bank_Charges"].includes(
      ["Bank_Exchange_Rate", "Bank_Charges"].includes(
        colName
      ) &&
      value < 0
    ) {
      commonToast("error", errorMessages[colName]);
      setIsSubmitting(false);
      return;
    }
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      // Auto-select logic for Txn Categorization and Broker Branch
      if (colName === "Txn_Category") {
        if (value === "Non Premium") {
          updatedRows[index][colName] = value;
          updatedRows[index]["Broker_Branch"] = "Non Premium";
          await instance
            .post(getBrokerBranchDetailsByBrokerBranchName, {
              Broker_Branch_Name: "Non Premium",
            })
            .then((response) => {
              updatedRows[index]["broker_information"] = response?.data?.id;
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        }
        else if (value !== "Non Premium" && rows[index][colName] === "Non Premium") {
          updatedRows[index][colName] = value ?? "";
          updatedRows[index]["Broker_Branch"] = "";
          updatedRows[index]["broker_information"] = "";
        }
        else {
          updatedRows[index][colName] = value ?? "";
        }
      }
      else {
        updatedRows[index][colName] = value;
      }
      setRows(updatedRows);
      validateRow(index);

      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handleBrokerBranchDropdown = (index, colName, value, reason, event) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      // Auto-select logic for Txn Categorization and Broker Branch
      if (value === "Non Premium") {
        updatedRows[index][colName] = value;
        updatedRows[index]["Txn_Category"] = "Non Premium";
      }
      else if (value !== "Non Premium" && rows[index][colName] === "Non Premium") {
        updatedRows[index][colName] = value ?? "";
        updatedRows[index]["Txn_Category"] = "";
      }
      else {
        updatedRows[index][colName] = value ?? "";
      }
      // get broker_information (Add Mode)
      instance
        .post(getBrokerBranchDetailsByBrokerBranchName, {
          Broker_Branch_Name: value,
        })
        .then((response) => {
          updatedRows[index]["broker_information"] = response?.data?.id;
          setRows(JSON.parse(JSON.stringify(updatedRows)));
          validateRow(index);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handlePaymentReferenceOpenDialog = (
    curindex,
    currentRowPaymentRefData
  ) => {
    setDialogType("PaymentReference");
    setOpenDialog(true);
    setDialogInputValue(currentRowPaymentRefData);
    setCurrentPaymentReferenceIndex(curindex);
  };

  const handleCommentOpenDialog = (
    curindex,
    currentRowCommentData
  ) => {
    setDialogType("Comment");
    setOpenDialog(true);
    setDialogInputValue(currentRowCommentData);
    setCurrentCommentIndex(curindex);
  };

  const handleCloseDialogs = () => {
    setOpenDialog(false);
    setDialogType("");
    setIsAuditOpen(false);
  };

  const handleSavePaymentReference = () => {
    setOpenDialog(false);
    setDialogType("");
    handleInputChange(
      currentPaymentReferenceIndex,
      "Payment_Reference",
      dialogInputValue
    ); // Pass the index parameter
  };

  const handleSaveComment = () => {
    setOpenDialog(false);
    setDialogType("");
    handleInputChange(
      currentCommentIndex,
      "comment",
      dialogInputValue
    ); // Pass the index parameter
  };

  const handleDialogInputChange = (e) => {
    setDialogInputValue(e.target.value);
  };

  const handleBlur = (index, colName, value) => {
    // If the value is float
    if (!Number.isInteger(value)) {
      switch (colName) {
        case "Bank_Charges":
        case "Receivable_Amount":
          value = parseFloat(value).toFixed(2);
          break;
        case "Bank_Exchange_Rate":
          value = parseFloat(value).toFixed(6);
          break;
        default:
          break;
      }
    }

    const updatedRows = [...rows];
    updatedRows[index][colName] = value;
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    const status = validateRow(rows.length - 1);
    if (status) {
      setRows([
        ...rows,
        { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
      ]);
      setDialogInputValue("");
    }
  };

  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (
      !row ||
      !row.Payment_Receive_Date ||
      !row.Payment_Receive_Date.trim() === ""
    ) {
      fieldValidations.Payment_Receive_Date = "This field is required";
    }

    if (
      !row ||
      !row.Payment_Reference ||
      !row.Payment_Reference.trim() === ""
    ) {
      fieldValidations.Payment_Reference = "This field is required";
    }

    // Update the logical OR conditions
    if (
      !row ||
      !row.Payment_Currency_Code ||
      !row.Payment_Currency_Code.trim() === ""
    ) {
      fieldValidations.Payment_Currency_Code = "This field is required";
    }

    if (
      !row ||
      !row.Receivable_Amount ||
      !row.Receivable_Amount.trim() === ""
    ) {
      fieldValidations.Receivable_Amount = "This field is required";
    }

    if (!row || !row.Txn_Category || !row.Txn_Category.trim() === "") {
      fieldValidations.Txn_Category = "This field is required";
    }

    if (!row || !row.Broker_Branch || !row.Broker_Branch.trim() === "") {
      fieldValidations.Broker_Branch = "This field is required";
    }

    // check if account number is selected
    if (!selectedOption) {
      fieldValidations.account_number = "This field is required";
    }

    if (row?.Txn_Category === "Non Premium" && (!row.comment || row.comment.trim() === "")) {
      fieldValidations.comment = "Comment is required when Txn Categorization is 'Non Premium'";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };

  const resetRowsToInitialState = () => {
    setRows([
      { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
    ]);
  };

  const handleSelectionModelChange = (newSelectionModel) => {
    setSelectionModel(newSelectionModel);

    if (newSelectionModel.length === 0) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };

  const handleFileUploadDialog = () => {
    setIsFileUploadDialogOpen(true);
  };

  const handleReloadAccountsData = () => {
    loadData();
  };

  // Handlers for checkbox filters - Single selection enforced
  const handleBankCheckboxChange = (bankName) => {
    setSelectedBanks((prev) => {
      if (prev.includes(bankName)) {
        // Deselect if already selected
        return prev.filter((b) => b !== bankName);
      } else {
        // Replace previous selection with new one (single selection)
        return [bankName];
      }
    });
  };

  const handleAccountCheckboxChange = (accountNo) => {
    setSelectedAccounts((prev) => {
      if (prev.includes(accountNo)) {
        // Deselect if already selected
        return prev.filter((a) => a !== accountNo);
      } else {
        // Replace previous selection with new one (single selection)
        return [accountNo];
      }
    });
  };

  const handleClearBankSearch = () => {
    setBankNameSearch("");
    setSelectedBanks([]);
  };

  const handleClearAccountSearch = () => {
    setAccountNoSearch("");
    setSelectedAccounts([]);
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { Bank_Transaction_Id } = searchFieldsPrams;
    if (
      selectedBanks.length > 0 ||
      selectedAccounts.length > 0 ||
      Bank_Transaction_Id !== "" ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };

  const handleSeeAllocations = () => {
    window.location.href = `/cash-allocation?txn_id=${isDeleteTxnIdValidation}`
  }

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchBankTransactionList();
    }
  };

  // ROE
  const [ROEList, UpdateROEList] = useState([]);

  useEffect(() => {
    const fetchROEList = async () => {
      try {
        const response = await instance.get(ROEFILTERAPI);
        if (response.status === 200) {
          UpdateROEList(response?.data);
        } else {
          UpdateROEList([]);
        }
      } catch (error) {
        UpdateROEList([]);
        console.error("Failed to fetch ROE list", error);
      }
    };
  
    fetchROEList();
  }, []);

  return (
    <div style={Container}>
      <Box
        sx={{
          "& .bankTransactionAddBtn": {
            backgroundColor: "#1672DE !important",
            "&:hover": {
              backgroundColor: "#1565c0 !important",
            },
          },
          "& .addBankTransactionSubmit": {
            backgroundColor: "#1672DE !important",
            "&:hover": {
              backgroundColor: "#1565c0 !important",
            },
          },
          "& .MuiTab-root": {
            "&.Mui-selected": {
              backgroundColor: "#1672DE !important",
              color: "white !important",
            },
          },
          "& .MuiCheckbox-root": {
            color: "#1672DE !important",
            "&.Mui-checked": {
              color: "#1672DE !important",
            },
            "&.MuiCheckbox-colorPrimary": {
              color: "#1672DE !important",
              "&.Mui-checked": {
                color: "#1672DE !important",
              },
            },
          },
        }}
      >
      <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "bankName",
              label: "Bank Name",
              placeholder: "Search banks",
              searchValue: bankNameSearch,
              onSearchChange: setBankNameSearch,
              items: banksList || [],
              selectedItems: selectedBanks,
              onItemChange: handleBankCheckboxChange,
              onClear: handleClearBankSearch,
              singleSelection: true, // Enable single selection mode
            },
            {
              type: "accountNo",
              label: "Account No",
              placeholder: "Search accounts",
              searchValue: accountNoSearch,
              onSearchChange: setAccountNoSearch,
              items: selectedBankAccount || [],
              selectedItems: selectedAccounts,
              onItemChange: handleAccountCheckboxChange,
              onClear: handleClearAccountSearch,
              singleSelection: true, // Enable single selection mode
            },
            {
              type: "textInput",
              label: "Transaction Id",
              placeholder: "Enter transaction ID",
              value: searchFieldsPrams?.Bank_Transaction_Id ?? "",
              onChange: (value) => handleBankTransactionIdchange("Bank_Transaction_Id", value),
              onKeyUp: handleEnter,
            },
            {
              type: "dateRange",
              label: "Transaction Period",
              startDate: fromDateValue,
              setStartDate: setFromDateValue,
              endDate: toDateValue,
              setEndDate: setToDateValue,
              maxDate: new Date(),
              onKeyUp: handleEnter,
            },
          ]}
          onApplyFilters={handleSearchBankTransactionList}
          onClearFilters={handleClearSearchList}
          isLoading={pageState?.isLoading}
          isFilterDisabled={isFilterBtnDisable()}
        />

        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Typography
                variant="h5"
                className="page-heading"
              >
                Bank Statement Transactions
              </Typography>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  minHeight: "36px",
                  width: "fit-content",
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .MuiTabs-flexContainer": {
                    width: "fit-content",
                  },
                }}
                aria-label="transaction tabs"
              >
                <Tab
                  label="Completed"
                  sx={{
                    borderRight: "1px solid #e0e0e0",
                    backgroundColor: tabValue === 0 ? "#1672DE !important" : "transparent !important",
                    color: tabValue === 0 ? "white !important" : "#666 !important",
                    borderRadius: "6px 0 0 6px",
                    minHeight: "36px",
                    minWidth: "100px",
                    maxWidth: "100px",
                    padding: "6px 16px",
                    textTransform: "none",
                    fontWeight: tabValue === 0 ? "600" : "400",
                    "&:hover": {
                      backgroundColor: tabValue === 0 ? "#1565c0 !important" : "rgba(22, 114, 222, 0.05) !important",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#1672DE !important",
                      color: "white !important",
                    },
                  }}
                />
                <Tab
                  label="Open"
                  sx={{
                    backgroundColor: tabValue === 1 ? "#1672DE !important" : "transparent !important",
                    color: tabValue === 1 ? "white !important" : "#666 !important",
                    borderRadius: "0 6px 6px 0",
                    minHeight: "36px",
                    minWidth: "100px",
                    maxWidth: "100px",
                    padding: "6px 16px",
                    textTransform: "none",
                    fontWeight: tabValue === 1 ? "600" : "400",
                    "&:hover": {
                      backgroundColor: tabValue === 1 ? "#1565c0 !important" : "rgba(22, 114, 222, 0.05) !important",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#1672DE !important",
                      color: "white !important",
                    },
                  }}
                />
              </Tabs>
            </Box>
            <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {bankTransactionPermisson?.["Allocation"] === "Y" && (
              <CommonButton
                sx={{
                  ...primaryButtonStyle,
                  background: isButtonDisabled ? "#CCCCCC" : primaryButtonStyle.backgroundColor,
                  "&:hover": {
                    background: isButtonDisabled ? "#CCCCCC" : primaryButtonHoverColor,
                  },
                  width: "91px",
                  padding: "8px 20px",
                }}
                text="Assign"
                handleClick={() => handleAssignButtonClick()}
                disabled={isButtonDisabled}
                hoverColor={primaryButtonHoverColor}
              />
            )}
            {bankTransactionPermisson?.["Creation TXN"] === "Y" && (
              <CommonButton
                text="Add"
                handleClick={() => handleAddTxnButton()}
                  sx={{
                    backgroundColor: "#1672DE !important",
                    color: "white !important",
                    borderRadius: "6px",
                    padding: "8px 20px",
                    fontWeight: "500",
                    "&:hover": {
                      backgroundColor: "#1565c0 !important",
                    },
                  }}
                className="bankTransactionAddBtn"
                  hoverColor="#1565c0"
                />
              )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
          display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "visible",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              paddingBottom: "10px",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          rowCount={pageState?.total}
          columns={columns}
          checkboxSelection
          disableRowSelectionOnClick
          keepNonExistentRowsSelected
          startIcon={<AddIcon />}
          getRowId={(row) => row?.id}
          pagination
          paginationMode="server"
          onSelectionModelChange={handleSelectionModelChange}
          selectionModel={selectionModel}
          disableSelectionOnClick
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 25}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(
                getPaginationCount(pageState?.total, newPageSize)
              );
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  overflow: "visible",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                    overflow: "visible",
                    textOverflow: "clip",
                    whiteSpace: "normal",
                    lineHeight: "1.4",
                    width: "100%",
                  },
                  "&.split-header .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "normal",
                    lineHeight: "1.3",
                    wordBreak: "break-word",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "#1672DE",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "#1672DE",
                  },
                },
                "& .MuiDataGrid-columnHeader[data-field='__check__']": {
                  minWidth: "58px !important",
                  maxWidth: "58px !important",
                  padding: "0 8px",
                  "& .MuiCheckbox-root": {
                    padding: "4px",
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiDataGrid-cell[data-field='__check__']": {
                  minWidth: "58px !important",
                  maxWidth: "58px !important",
                  padding: "0 8px",
                  justifyContent: "center",
                  "& .MuiCheckbox-root": {
                    padding: "4px",
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiCheckbox-root": {
                  color: "#1672DE",
                  "&.Mui-checked": {
                    color: "#1672DE",
                  },
                  "&.MuiCheckbox-colorPrimary": {
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                  },
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08)",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12)",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
            "& .MuiDataGrid-columnHeader[data-field='File_Name']": {
              minWidth: toggle?.isOpen
                ? "173.137px !important"
                : "202px !important",
            },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  backgroundColor: "#f8f9fa",
                  minHeight: "48px",
                  maxHeight: "48px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "16px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                  "& .MuiTablePagination-displayedRows": {
                    fontSize: "13px",
                    margin: 0,
                  },
                  "& .MuiTablePagination-actions": {
                    marginLeft: "8px",
                    "& .MuiIconButton-root": {
                      padding: "4px",
                    },
                  },
                  "& .MuiTablePagination-select": {
                    margin: "0 8px",
                    padding: "4px 8px",
                  },
                  "& .MuiTablePagination-toolbar": {
                    minHeight: "32px",
                    padding: 0,
                  },
                },
                "& .MuiDataGrid-toolbarContainer": {
                  padding: "12px 16px",
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  "& .MuiButton-root": {
                    color: "#1672DE",
                    fontSize: "13px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.1)",
                    },
                  },
                },
                "& .MuiDataGrid-loadingOverlay": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
            },
          }}
          components={{
                Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ color: "#999" }}
                  >
                    <Typography variant="body2" sx={{ color: "#999" }}>
                      No Transactions Found
                    </Typography>
              </Stack>
            ),
          }}
        />
        <Stack
              sx={{
            position: "absolute",
                bottom: "16px",
                right: "20px",
                zIndex: 10,
                backgroundColor: "#f8f9fa",
                padding: "4px 8px",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={isOpenAddBankTxnDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ style: dialogStyle }}
      >
        <DialogTitle 
          id="alert-dialog-title" 
          sx={{ 
            cursor: "default",
            backgroundColor: "#1672DE",
            color: "white"
          }}
        >
          {"Add Bank Transaction"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon className="CloseIconStyle" sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <Grid display={"flex"} flexDirection={"column"}>
            <Card elevation={5} className="EditPageContainer">
              <Grid
                xs={12}
                gap={1}
                container
                className="EditpageContainerItems"
              >
                <Grid
                  item
                  xs={12}
                  md={2}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                >
                  <FormLabel>
                    Select Account No
                    {!viewMode && <span style={{ color: "red" }}>*</span>}
                  </FormLabel>
                  <CommonSelect
                    name="accountNo"
                    placeholder="Select Account No"
                    value={selectedOption}
                    handleChange={(event, value, reason) =>
                      handleBankAccountDropdownChange(value, reason)
                    }
                    options={
                      accountsList?.map((option) =>
                        option?.account_number?.trim()
                      ) || []
                    }
                    disabled={viewMode}
                  />
                  {validationStatus.map(
                    (item) =>
                      item?.account_number && (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {item?.account_number}
                        </Typography>
                      )
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2.5}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"5px"}
                >
                  <FormLabel>Bank Name</FormLabel>
                  <TextField
                    value={responseData?.bank_name ?? ""}
                    size="small"
                    disabled={viewMode}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2.5}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"5px"}
                >
                  <FormLabel>Entity Name</FormLabel>
                  <TextField
                    value={responseData?.entity_name ?? ""}
                    size="small"
                    disabled={viewMode}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"5px"}
                >
                  <FormLabel>Currency</FormLabel>
                  <TextField
                    value={responseData?.currency ?? ""}
                    size="small"
                    disabled={viewMode}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  display={"flex"}
                  justifyContent={"center"}
                  alignSelf={"end"}
                  gap={"5px"}
                >
                  {!editMode && !viewMode && (
                    <div className="FileUploadIcon">
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        onClick={handleFileUploadDialog}
                      >
                        <span
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          Files: <AttachFileIcon />
                        </span>
                        {uploadedFiles[0]?.name}
                      </div>

                      <CommonFileUpload
                        isFileUploadDialogOpen={isFileUploadDialogOpen}
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        setIsFileUploadDialogOpen={setIsFileUploadDialogOpen}
                      />
                    </div>
                  )}
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <div elevation={6} className="EditPageContainerTransactions">
            <div className="EditPageContainerTransactionsList">
              <p style={{ color: "black" }}>Transactions</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <CommonButton
                  text="Add"
                  handleClick={handleAddRow}
                  icon={<AddIcon style={{ height: "18px" }} />}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                    },
                  }}
                />
                <CommonButton
                  sx={{
                    backgroundColor: selectAll ? "#1672DE" : "#CCCCCC",
                    color: selectAll ? "white" : "black",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "17px 10px",
                    borderRadius: "15px",
                    "&:hover": {
                      background: selectAll ? "#1565c0" : "#CCCCCC",
                    },
                  }}
                  text="Delete"
                  handleClick={handleDeleteRow}
                  disabled={selectedRows.length === 0}
                  icon={<DeleteIcon style={{ height: "19px" }} />}
                />
              </div>
            </div>

            {isCreateNewTransaction && (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddBnkTransactionDetails
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  handleBrokerBranchDropdown={handleBrokerBranchDropdown}
                  viewMode={viewMode}
                  validationStatus={validationStatus}
                  dropdownValuesCurreny={dropdownValuesCurreny}
                  dropdownValuesTxnCategory={dropdownValuesTxnCategory}
                  brokerBranches={brokerBranches}
                  handlePaymentReferenceOpenDialog={
                    handlePaymentReferenceOpenDialog
                  }
                  handleCommentOpenDialog={handleCommentOpenDialog}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            )}
          </div>
        </DialogContent>

        <DialogActions className="resetSubmit">
          {isCreateNewTransaction && (
            <>
              <CommonButton
                className="addBankTransactionReset"
                text="Reset"
                handleClick={() => setOpenResetDialog(true)}
                disabled={editMode}
              />
              <CommonButton
                className="addBankTransactionSubmit"
                text="Submit"
                handleClick={handleSubmit}
                hoverColor="#1565c0"
                disabled={isSubmitting} // Disable the button when submitting
                sx={{
                  backgroundColor: isSubmitting ? "#CCCCCC !important" : "#1672DE !important",
                  color: isSubmitting ? "#666666 !important" : "white !important",
                  "&:hover": {
                    backgroundColor: isSubmitting ? "#CCCCCC !important" : "#1565c0 !important",
                  },
                }}
              />
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* ViewAndEditBankTransaction */}
      {isOpenTxnDialog && (
        <ViewAndEditBankTransaction
          isOpenTxnDialog={isOpenTxnDialog}
          setIsOpenTxnDialog={setIsOpenTxnDialog}
          txnMode={txnMode}
          txnData={currentRow}
          handleReloadAccountsData={handleReloadAccountsData}
          navigatedFrom="BANK_TRANSACTION"
        />
      )}

      <DialogBox
        title="Assign To"
        body={
          <FormControl style={{ width: "100%" }}>
            <label style={{ marginBottom: 10 }}>Assigning to </label>
            <CommonSelect
              name="assigning"
              value={selectedUser}
              handleChange={(event, value, reason) =>
                setSelectedUser(value, reason)
              }
              options={users?.map((option) => option?.user_name)}
            />
          </FormControl>
        }
        confirmText="Assign"
        isOpen={isDialogOpen}
        onCancel={handleCloseDialog}
        onConfirm={handleSubmitAssing}
        isDisableConfirm={isAssignToTxnApiProgress}
      />
      <Dialog open={openDialog} onClose={handleCloseDialogs}>
        <DialogTitle>{dialogType === "PaymentReference" ? "Payment Reference" : dialogType === "Comment" ? "Comment" : ""}</DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogInputValue}
            onChange={handleDialogInputChange}
            className="PaymentReferenceDialogue"
          />
        </DialogContent>
        <DialogActions>
          <CommonButton
            text="Cancel"
            handleClick={handleCloseDialogs}
            sx={{
              backgroundColor: "#ffff",
              color: "#000000",
              border: "1px solid #BCBDBF",
            }}
          />
          <CommonButton
            text="Save"
            handleClick={dialogType === "PaymentReference" ? handleSavePaymentReference : dialogType === "Comment" ? handleSaveComment : null}
            hoverColor="#1565c0"
            sx={{
              backgroundColor: "#1672DE",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          />
        </DialogActions>
      </Dialog>

      <DialogBox
        title="Delete Confirmation"
        body="Are you sure you want to delete this item?"
        confirmText="Delete"
        isOpen={open}
        onCancel={handleDeleteCancelled}
        onConfirm={handleDeleteConfirmed}
        isDisableConfirm={isDeletebankTxnProgress}
      />

      <DialogBox
        title="Reset Confirmation"
        body="Are you sure you want to reset?"
        confirmText="Yes"
        cancelText="No"
        isOpen={openResetDialog}
        onCancel={() => setOpenResetDialog(false)}
        onConfirm={handleReset}
      />

      <DialogBox
        title="Warning !!"
        body="Once deleted the transaction cannot be reverted! Please confirm to delete."
        confirmText="See Allocations"
        deleteBtnText="Delete"
        isOpen={openErrorDialog}
        onCancel={handleErrorDialogClose}
        onConfirm={handleSeeAllocations}
        deletePopup={() => setOpen(true)}
      />

      {/* Bank Statement Audit Trail model */}
      {isAuditOpen && (
        <Dialog 
          open={isAuditOpen} 
          onClose={handleCloseDialogs} 
          maxWidth='lg'
          fullWidth
          sx={{ width: "100%", height: "80vh", marginTop: "5%" }}
        >
          <DialogTitle sx={{fontSize: "1.5rem"}}>Audit Trail</DialogTitle>
          <DialogContent sx={{ overflow: "hidden", height: "70vh" }}>
            <Grid container spacing={2} mt={2} paddingLeft={2}>
              <Grid item xs={12}>
                <div style={{height: "50vh", overflowY: "auto"}}>
                  <table style={{width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f5f5f5' }}>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                        {/* <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Timestamp</th> */}
                        <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRow && currentRow?.bank_transaction_audit_data?.map((audit, index) => (
                      <tr key={index}>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.field_name}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.old_value}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.new_value}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.changed_by}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.current_edit_datetime}</td>
                          {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.time_diff}</td> */}
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.event_type === 'add' ? 'Added bank statement' : audit.event_type}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
          </DialogActions>
        </Dialog>
      )}

      {/* Activity Menu */}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby={`demo-positioned-button-${currentRow?.id}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose("")}
        className="cash-allocation-table-action-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              minWidth: '120px',
            }
          }
        }}
      >
        {policyActions.map((item) => (
          <MenuItem
            key={item.id}
            className="cash-allocation-table-action-item"
            onClick={() => handleClose(item.id, currentRow)}
          >
            {item.label}
            <ArrowForwardIosIcon
              className="cash-allocation-table-action-icon"
              fontSize="small"
            />
          </MenuItem>
        ))}
      </Menu>

      {/* Activity dialogue */}
      <DialogueContainer
        id={openDialogueId}
        allocation={dialogueAllocation}
        transaction={dialogueAllocation}
        onClose={handleClose}
        currencies={currencies}
        isAuthorizedUser={true}
        isBankActivity={true}
        ROEList={ROEList}
        UpdateROEList={UpdateROEList}
      />
      </Box>
    </div >
  );
}
